"use client";

import LeftColumn from "@/components/LeftColumn";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import ExpiryGuard from "@/components/ExpiryGuard";
import {
    LocaleProvider,
    SupportedLocale,
} from "@habacuscode/habacus_ui_component_library";
import { useMessages } from "next-intl";
import { useEffect } from "react";
import { signInAnonymously } from "firebase/auth";
import { getFirebaseClientAuth } from "@/lib/firebase-client-config";

export default function ClientTenantLayout({
    locale,
    children,
}: Readonly<{ locale: SupportedLocale; children: React.ReactNode }>) {
    const messages = useMessages();

    // sessione Firebase anonima -> fornisce l'idToken per autenticare le /api
    useEffect(() => {
        (async () => {
            try {
                const auth = await getFirebaseClientAuth();
                if (auth && !auth.currentUser) {
                    await signInAnonymously(auth);
                }
            } catch (e) {
                console.error("Firebase anonymous sign-in failed", e);
            }
        })();
    }, []);

    return (
        <LocaleProvider locale={locale} messages={messages}>
            <ExpiryGuard locale={locale} />
            <div className="flex flex-col lg:flex-row min-h-screen">
                <div className="order-2 lg:order-1 w-full lg:w-[35%]">
                    <LeftColumn />
                </div>
                <div className="relative order-1 lg:order-2 w-full lg:flex-1">
                    <div className="absolute top-0 right-0 z-10 px-4 pt-4">
                        <LanguageSwitcher />
                    </div>
                    {children}
                </div>
            </div>
        </LocaleProvider>
    );
}
